import UniversalResource from "./universal.resource";

const universalModule = angular
  .module("app.resources.universal", [])
  .service("Universal", UniversalResource);

export default universalModule;



// WEBPACK FOOTER //
// ./src/resources/universal/universal.module.js